import type { ReactNode } from "react";

type Tone = "neutral" | "low" | "medium" | "high" | "critical" | "success" | "warning";

const tones: Record<Tone, string> = {
  neutral: "border-white/10 bg-white/5 text-slate-200",
  low: "border-trust/30 bg-trust/10 text-trust",
  medium: "border-amber-300/30 bg-amber-300/10 text-amber-200",
  high: "border-orange-400/30 bg-orange-400/10 text-orange-200",
  critical: "border-red-400/40 bg-red-500/10 text-red-300",
  success: "border-emerald-400/30 bg-emerald-400/10 text-emerald-200",
  warning: "border-amber-400/30 bg-amber-400/10 text-amber-200",
};

export function Badge({
  tone = "neutral",
  children,
}: {
  tone?: Tone;
  children: ReactNode;
}) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${tones[tone]}`}
    >
      {children}
    </span>
  );
}

export function urgencyTone(urgency: string): Tone {
  if (urgency === "critical") return "critical";
  if (urgency === "high") return "high";
  if (urgency === "medium") return "medium";
  return "low";
}
